<template lang="html">
    <div id="page__search" class="toolbar-search">
        <z-select v-model="filter.type" v-on:input="onFilter" light>
            <option selected disabled value=""> Все </option>
            <option v-bind:value="1"> Автофургон </option>
            <option v-bind:value="2"> Тягач </option>
            <option v-bind:value="3"> Прицеп </option>
        </z-select>
        <input 
            type="text" placeholder="Номер автомобиля/прицепа..." v-model="filter.search"  class="toolbar-search__input"
            v-on:keyup="onSearchFilter" v-on:keyup.enter="onFilter"
        ></input>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light @click="onReset" v-bind:disabled="!hasFilter"></z-icon-button>
    </div>
</template>
<script>
    import ZSelect from '@/components/ZSelect';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {ZSelect, ZIconButton},
        data() {
            return {
                filter: {
                    search: null,
                    type: ''
                },
                filterDefault: {
                    search: null,
                    type: ''
                },
                focus: false,
                onBlur: true
            }
        },
        created() {
            this.resolveQueryFilter();
        },
        watch: {
        },
        computed: {
            /**
             * Показ кнопки удаления фильтра фильтра
             */
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            }
        },
        methods: {
            /**
             * Подставление фильтра при перезагрузке
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter))
            },
            /**
             * Фильтрация по строке
             */
            onSearchFilter() {
                if (!this.filter.search || (this.filter.search && this.filter.search.length < 3)) return;
                this.onFilter();
            },
            /**
             * Фильрация
             */
            onFilter() {
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'autos');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'autos');
            }
        },
    }
</script>



// WEBPACK FOOTER //
// AutoToolbar.vue?47421868